import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { createRoot } from "react-dom/client";
import { CONTAINER_CLASS, DEFAULT_CONTAINER_ID } from "./const";
import { Layer } from "./Layer";
import styles from "./index.css";
var Container = /** @class */ (function () {
    function Container(customId) {
        this.customId = customId;
        this.layers = [];
        this.id = ++Container._id;
    }
    Object.defineProperty(Container.prototype, "rootElem", {
        get: function () {
            if (!this._rootElem) {
                var root = document.createElement("div");
                root.id =
                    this.customId ||
                        (this.id
                            ? "".concat(DEFAULT_CONTAINER_ID, "_").concat(this.id)
                            : DEFAULT_CONTAINER_ID);
                root.classList.add(CONTAINER_CLASS, styles.container);
                this._rootElem = root;
                document.body.appendChild(this._rootElem);
            }
            return this._rootElem;
        },
        enumerable: false,
        configurable: true
    });
    Container.prototype.active = function () {
        var rootElem = this.rootElem;
        if (!this.rootRender) {
            this.rootRender = createRoot(rootElem);
        }
        return this.rootRender;
    };
    Container.prototype.dispose = function () {
        var _a, _b;
        (_a = this.rootElem) === null || _a === void 0 ? void 0 : _a.remove();
        (_b = this.rootRender) === null || _b === void 0 ? void 0 : _b.unmount();
    };
    Container.prototype.render = function () {
        var root = this.active();
        root.render(_jsx(_Fragment, { children: this.layers.map(function (layer) {
                return _jsx(layer.View, {}, layer.id);
            }) }));
    };
    Container.prototype.show = function (renderer, options) {
        var layer = new Layer(this, renderer, options);
        this.layers.push(layer);
        this.render();
        return layer;
    };
    Container.prototype.remove = function (layer) {
        var idx = this.layers.indexOf(layer);
        if (idx >= 0)
            this.layers.splice(idx, 1);
        this.render();
    };
    Container._id = 0;
    return Container;
}());
export { Container };
